import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSectionClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          const navHeight = 80; // Account for fixed navigation height
          const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navHeight;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-8 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a 
            href="/"
            onClick={(e) => {
              e.preventDefault();
              if (window.REACT_APP_NAVIGATE) {
                window.REACT_APP_NAVIGATE('/');
              }
            }}
            className="text-2xl font-serif font-bold text-gray-900 cursor-pointer"
          >
            Melinda Holcomb
          </a>

          {/* Navigation Links */}
          <div className="flex items-center gap-8">
            <a 
              href="/"
              onClick={(e) => {
                e.preventDefault();
                if (window.REACT_APP_NAVIGATE) {
                  window.REACT_APP_NAVIGATE('/');
                }
              }}
              className="text-sm font-medium text-gray-800 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Home
            </a>
            <a 
              href="/#about"
              onClick={(e) => handleSectionClick(e, 'about')}
              className="text-sm font-medium text-gray-800 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              About
            </a>
            <a 
              href="/#books"
              onClick={(e) => handleSectionClick(e, 'books')}
              className="text-sm font-medium text-gray-800 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Books
            </a>
            <a 
              href="/#blog"
              onClick={(e) => handleSectionClick(e, 'blog')}
              className="text-sm font-medium text-gray-800 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Blog
            </a>
            <a 
              href="/#contact"
              onClick={(e) => handleSectionClick(e, 'contact')}
              className="text-sm font-medium text-gray-800 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact
            </a>
            <a 
              href="/videos"
              className="text-sm font-medium text-gray-800 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Videos
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
